import { render, staticRenderFns } from "./SocialNotificationList.vue?vue&type=template&id=28256122&scoped=true&"
import script from "./SocialNotificationList.vue?vue&type=script&lang=js&"
export * from "./SocialNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./SocialNotificationList.vue?vue&type=style&index=0&id=28256122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28256122",
  null
  
)

/* custom blocks */
import block0 from "./SocialNotificationList.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports